import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_QRS_SUCCESS,
  DELETE_QRS_SUCCESS,
  GET_QRS_FAIL,
  GET_QRS_SUCCESS,
  UPDATE_QRS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  idsqr: [],
  defective: [],
 
  error: {},
};

const QRS = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QRS_SUCCESS:
      return {
        ...state,
        idsqr: action.payload.apples,
       
        defective: action.payload.defective,
      };

    case GET_QRS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_QRS_SUCCESS:
      return {
        ...state,
        idsqr: [...state.idsqr, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_QRS_SUCCESS:
      return {
        ...state,
        idsqr: state.idsqr.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_QRS_SUCCESS:
      return {
        ...state,
        idsqr: state.idsqr.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default QRS;
